'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
export { AD_SLOT_DEBUG_PLACEHOLDER_ENABLED } from '@/constants/ad';
interface AdSlotDebugPlaceholderProps {
  //* width/height 생략 시 부모 frame이 크기를 소유한다 (className="size-full"로 채움)
  width?: number;
  height?: number;
  rounded?: 'medium' | 'large';
  className?: string;
}
export const AdSlotDebugPlaceholder = t0 => {
  const $ = _c(11);
  const {
    width,
    height,
    rounded: t1,
    className
  } = t0;
  const rounded = t1 === undefined ? "large" : t1;
  const t2 = rounded === "medium" ? "rounded-medium" : "rounded-large";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("pointer-events-none flex-col gap-4 border border-dashed border-Gray-300 bg-Gray-100 text-Gray-500 flex-center", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== height || $[4] !== width) {
    t4 = width !== undefined && height !== undefined ? {
      width: `min(100%, ${width}px)`,
      aspectRatio: `${width} / ${height}`
    } : undefined;
    $[3] = height;
    $[4] = width;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="font-700 typo-caption1">AD</span>;
    t6 = <span className="font-500 typo-caption2">개발용 광고 영역</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t4) {
    t7 = <div aria-hidden={true} data-ad-debug-placeholder={true} className={t3} style={t4}>{t5}{t6}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};